import { render, staticRenderFns } from "./S1Icon.vue?vue&type=template&id=ccb1e1bc&"
import script from "./S1Icon.vue?vue&type=script&lang=js&"
export * from "./S1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports